import { IconMagicSolid, Text } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import {
  GlobalSearchSuggestedPromptListStyled,
  GlobalSearchSuggestedPromptStyled,
  GlobalSearchSuggestedPromptsHeadingStyled,
} from './styles/GlobalSearchSuggestedPromptsStyled'
import { SUGGESTED_PROMPT_MESSAGES } from './suggestedPromptMessages'

interface IGlobalSearchSuggestedPromptsProps {
  onPromptClick: (query: string) => void
}

export const GlobalSearchSuggestedPrompts = ({
  onPromptClick,
}: IGlobalSearchSuggestedPromptsProps) => {
  const intl = useProcurifyIntl()

  return (
    <>
      <GlobalSearchSuggestedPromptsHeadingStyled color='textSecondary'>
        {intl.formatMessage(messages.heading)}
      </GlobalSearchSuggestedPromptsHeadingStyled>
      <GlobalSearchSuggestedPromptListStyled
        aria-label={intl.formatMessage(messages.listAriaLabel)}
      >
        {SUGGESTED_PROMPT_MESSAGES.map((message) => {
          const query = intl.formatMessage(message)

          return (
            <li key={message.id}>
              <GlobalSearchSuggestedPromptStyled
                type='button'
                data-analytics-id='global-command-suggested-prompt'
                onClick={() => onPromptClick(query)}
              >
                <IconMagicSolid size={16} color='ai' />
                <Text inline color='ai'>
                  {query}
                </Text>
              </GlobalSearchSuggestedPromptStyled>
            </li>
          )
        })}
      </GlobalSearchSuggestedPromptListStyled>
    </>
  )
}
